import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from './TextField';
import { Icon } from './Icon';

import styles from './paramsCard/list/list.module.scss';

export class ParamsCardsList extends React.Component {
  componentDidUpdate(prevProps) {
    const { isSearchOpen } = this.props;
    if (!prevProps.isSearchOpen && isSearchOpen && this.inputRef) {
      this.inputRef.focus();
    }
  }

  onListScroll = ({ target }) => {
    const { loadData, isFetching } = this.props;
    if (isFetching) {
      return;
    }

    if (target.scrollHeight - target.offsetHeight === target.scrollTop) {
      loadData();
    }
  }

  getInputRef = (el) => {
    this.inputRef = el;
  }

  render() {
    const {
      className = '',
      children,
      searchValue,
      onSearchChange,
      toggleSearch,
      isSearchOpen,
      loadData,
      isFetching,
      skeleton,
      noSearch,
    } = this.props;

    return (
      <div className={`${styles.container} ${className}`}>
        {noSearch ? null : (
          <div className={styles.search}>
            {isSearchOpen ? (
              <div className={styles.searchWrapper}>
                <TextField
                  className={styles.textField}
                  label="Search"
                  iconName="Search"
                  value={searchValue}
                  onChange={onSearchChange}
                  inputRef={this.getInputRef}
                />
                <button
                  className={`btn-cross ${styles.close}`}
                  onClick={toggleSearch}
                />
              </div>
            ) : (
              <button
                className={styles.showSearch}
                onClick={toggleSearch}
              >
                <Icon name="Search" />
              </button>
            )}
          </div>
        )}
        <div
          className={styles.list}
          onScroll={loadData ? this.onListScroll : null}
        >
          {children}
          {isFetching &&
            skeleton
          }
        </div>
      </div>
    );
  }
}

ParamsCardsList.propTypes = {
  className: PropTypes.string,
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  toggleSearch: PropTypes.func,
  isSearchOpen: PropTypes.bool,
  noSearch: PropTypes.bool,
  loadData: PropTypes.func,
  isFetching: PropTypes.bool,
  skeleton: PropTypes.element,
};
